import { createRoot } from "react-dom/client";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { ConfigProvider } from "antd";
import "@ant-design/v5-patch-for-react-19";
import { themeProps } from "@alphascriptsolutions/client-core";
import "../../styles/globals.css";
import App from "./App";

const rootElement: HTMLElement | null = document.getElementById("errorPopupRoot");
const root = rootElement ? createRoot(rootElement) : undefined;

Office.onReady(() => {
    root?.render(
      <ConfigProvider theme={{
        ...themeProps,
        components: {
          ...themeProps.components,
          Tree: {
            nodeHoverColor: '#ff5c35',
            nodeSelectedBg: '#f5f5f5',
            nodeSelectedColor: '#ff5c35',
          },
        },
        token: {
          ...themeProps.token,
          fontSize: 13,
        },
      }}>
        <FluentProvider theme={webLightTheme}>
          <App />
        </FluentProvider>
      </ConfigProvider>
    );
  });